module.exports = __webpack_public_path__ + "static/img/banner.386ee8d6.jpg";